export const environment = {
  production: true,
  firebaseIsAvailable: false,
  jivochat: false,
  name_env: 'beta',
  version: '2.22.1.20261022',
  url_api: 'https://apibeta.trip2.com/REST/',
  url_signalr: 'https://apibeta.trip2.com/signalr',
  url_webapp: 'https://webapp.trip2.com/#/auth/login',
  url_osrm: 'https://osrm.trip2.com/',
  parse: {
    server_url: 'https://support.trip2.com/parse/',
    liveQueryServerURL: 'wss://support.trip2.com',
    app_name: 'Super Log',
    app_id: '146f36bb-2bb8-49c3-8777-796a7b2497fe',
    master_key: '1455492a-c2ba-4468-bc1f-5faefb97fa8d',
    models: {
      versions: {
        name: 'versions',
        name_row: 'beta',
        id_row: '15ZJIft8kx'
      }
    }
  },
  config_firebase: {
    apiKey: 'AIzaSyAqOI0IuPOxMyeCOLWfoxW60xfnrEgSNEU',
    authDomain: 'trip2-cms-prod.firebaseapp.com',
    databaseURL: 'https://api-6307658231561989783-512121-default-rtdb.firebaseio.com',
    projectId: 'trip2-cms-prod',
    storageBucket: 'trip2-cms-prod.appspot.com',
    messagingSenderId: '470141718657',
    appId: '1:470141718657:web:873c3212a83d67a706fd80',
    measurementId: 'G-6LEC4Q1JGJ'
  },
  firebaseAuth: {
    email: 'admin@transportationamerica.com',
    password: 'Ee"XaaZ@,zh6fB7T'
  },
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts